import { queryOptions, useQuery } from '@tanstack/react-query';
import { attributesQueries, FetchEmployeeAttributesQuery } from '../queries/attributes.queries';
import { appQueryClient } from '~/adapters/reactQuery';

const attributesKeys = {
  fetchEmployeeAttributes: (query: FetchEmployeeAttributesQuery) => ['employeeAttributes', query],
};

const fetchEmployeeAttributesOptions = (
  query: FetchEmployeeAttributesQuery,
  { skip = false }: { skip?: boolean } = {},
) => {
  return queryOptions({
    queryKey: attributesKeys.fetchEmployeeAttributes(query),
    queryFn: () => attributesQueries.fetchEmployeeAttributes(query),
    enabled: !skip,
    staleTime: 0,
  });
};

export const useFetchEmployeeAttributesQuery = (
  query: FetchEmployeeAttributesQuery,
  { skip = false }: { skip?: boolean } = {},
) => {
  return useQuery(fetchEmployeeAttributesOptions(query, { skip }));
};

export const fetchEmployeeAttributesQuery = (query: FetchEmployeeAttributesQuery) => {
  return appQueryClient.fetchQuery(fetchEmployeeAttributesOptions(query, { skip: false }));
};
